import React from 'react';
import { motion } from 'framer-motion';

const AnimatedSection = ({ children, stagger = 0.2, amount = 0.3, index, align }) => {
    const containerVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5, staggerChildren: stagger } }
    };

    const itemVariants = (index) => ({
        hidden: { opacity: 0, x: index % 2 === 0 ? 50 : -50 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
    });

    return (
        <motion.div
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount }}
            style={{ width: '100%', textAlign: align,height: '95%' }}
        >
            <motion.div variants={itemVariants(index)}style={{height: '100%'}}>
                {children}
            </motion.div>
        </motion.div>
    );
};

export default AnimatedSection;
